webpackJsonp([41],{

/***/ "4k6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckIp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");



var CheckIp = function CheckIp(Path) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/access', {
    'path': Path
  });
};

/***/ }),

/***/ "9DFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja__ = __webpack_require__("7Ppv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja__);




__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.localize('ja', __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_ja___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */], { locale: 'ja' });

/***/ }),

/***/ "9KKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appWhitelist; });
var appWhitelist = [['setToken'], ['logout'], ['trainingRecord'], ['examRecord'], ['training']];

/***/ }),

/***/ "9KlH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return popAuthList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkRefreshToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

var getTokens = function getTokens(shainNo, tokenId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/tokens/' + shainNo + '/' + tokenId);
};

var popAuthList = function popAuthList(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/auth/get/' + shainNo);
};

var deleteToken = function deleteToken(shainNo, refreshToken) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/token/delete', {
    shain_no: shainNo - 0,
    token: refreshToken + ''
  });
};

var checkAccessToken = function checkAccessToken(shainNo, token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/accessToken/check', {
    shain_no: shainNo - 0,
    token: token
  });
};

var checkRefreshToken = function checkRefreshToken(shainNo, token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["c" /* authUrl */] + '/api/refreshToken/check', {
    shain_no: shainNo - 0,
    token: token
  });
};

/***/ }),

/***/ "AMf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

const apiUrl = '//testback-chienowa.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["a"] = apiUrl;

const authUrl = '//testauth.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["c"] = authUrl;

const myUrl = 'testchienowa.n-links.biz'
/* harmony export (immutable) */ __webpack_exports__["d"] = myUrl;

const appName = 'chienowa-test'
/* harmony export (immutable) */ __webpack_exports__["b"] = appName;



/***/ }),

/***/ "AZxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCESS_TOKEN; });
/* unused harmony export REFRESH_TOKEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHAIN_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHAIN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LEVEL; });
/* unused harmony export SEARCH_SHAIN_NO */
/* unused harmony export POSITION_DISP_DATA */
/* unused harmony export POSITION_FLG_LIST */
/* unused harmony export OFFICEMASTER_ADDRESS */
/* unused harmony export OFFICEMASTER_OPEN_ON */
/* unused harmony export OFFICEMASTER_CLOSE_ON */
/* unused harmony export OFFICEMASTER_IS_HIDDEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MENU; });
var ACCESS_TOKEN = 'ACCESS_TOKEN';
var REFRESH_TOKEN = 'REFRESH_TOKEN';
var SHAIN_NO = 'SHAIN_NO';
var SHAIN_NAME = 'SHAIN_NAME';
var AUTH_LEVEL = 'AUTH_LEVEL';
var SEARCH_SHAIN_NO = 'SEARCH_SHAIN_NO';
var POSITION_DISP_DATA = 'POSITION_DISP_DATA';
var POSITION_FLG_LIST = 'POSITION_FLG_LIST';
var OFFICEMASTER_ADDRESS = 'OFFICEMASTER_ADDRESS';
var OFFICEMASTER_OPEN_ON = 'OFFICEMASTER_OPEN_ON';
var OFFICEMASTER_CLOSE_ON = 'OFFICEMASTER_CLOSE_ON';
var OFFICEMASTER_IS_HIDDEN = 'OFFICEMASTER_IS_HIDDEN';
var MENU = 'MENU';

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage_js__ = __webpack_require__("laiv");


var _mutations, _actions;




var state = {
  accessToken: null,
  refreshToken: null,
  shainNo: null,
  shainName: '',
  authLevel: null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], function (state, _ref) {
  var token = _ref.token;

  // api.header(token)
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_storage_js__["d" /* setSessionStore */])('ACCESS_TOKEN', token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["e" /* SHAIN_NO */], function (state, _ref2) {
  var num = _ref2.num;

  state.shainNo = num;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["d" /* SHAIN_NAME */], function (state, _ref3) {
  var name = _ref3.name;

  state.shainName = name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], function (state, _ref4) {
  var auth = _ref4.auth;

  state.authLevel = auth;
}), _mutations);

var getters = {
  getShainName: function getShainName(state) {
    return state.shainName;
  },
  getAccessToken: function getAccessToken(state) {
    return state.accessToken;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], function (_ref5, token) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["a" /* ACCESS_TOKEN */], { token: token });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["e" /* SHAIN_NO */], function (_ref6, num) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["e" /* SHAIN_NO */], { num: num });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["d" /* SHAIN_NAME */], function (_ref7, name) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["d" /* SHAIN_NAME */], { name: name });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], function (_ref8, auth) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["b" /* AUTH_LEVEL */], { auth: auth });
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth_js__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_transition_js__ = __webpack_require__("pyT+");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth_js__["a" /* default */],
    transition: __WEBPACK_IMPORTED_MODULE_4__modules_transition_js__["a" /* default */]
  },
  state: {
    loading: false,
    forbidden: false,
    progressState: false,
    progress: 0
  },
  mutations: {
    onLoading: function onLoading(state, mode) {
      state.loading = mode;
    },
    forbidden: function forbidden(state, mode) {
      state.forbidden = mode;
    },
    inProgress: function inProgress(state, mode) {
      state.progressState = mode;
    },
    setProgress: function setProgress(state, mode) {
      state.progress = mode;
    }
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])()]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KF9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate_validate__ = __webpack_require__("9DFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui__ = __webpack_require__("yweG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_at_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_at_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_at_ui_style__ = __webpack_require__("KF9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_at_ui_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_at_ui_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowjs_flow_js__ = __webpack_require__("7EEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowjs_flow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowjs_flow_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





 // Import CSS


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_at_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<router-view></router-view>'
});

/***/ }),

/***/ "T3K/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return funcId; });
var funcId = {
  // なし
  none: 0,
  // 研修実施結果記録
  trainingRecord: 1,
  // テスト実施結果記録
  examRecord: 2,
  // 研修検索
  training: 101,
  // 研修検索編集
  trainingEdit: 104,
  // 実施研修検索
  replicationTraining: 201,
  // 実施編集
  replicationEdit: 204,
  // テスト検索
  exam: 301,
  // テスト編集
  examEdit: 305,
  // 実施テスト検索
  replicationExam: 401,
  // 実施テスト実施状況閲覧
  replicationExamCondition: 402,
  // 実施テスト一括採点
  replicationExamScoring: 408,
  // 未実施遺留
  // 研修登録
  trainingRegister: 501,
  // テスト登録
  examRegister: 601,
  // 実施設定登録
  replicationRegister: 701,
  // 未実施登録
  unadministeredRegister: 704,
  // カテゴリマスタ閲覧
  category: 801,
  // カテゴリマスタ新規登録
  categoryRegister: 802,
  // カテゴリマスタ編集
  categoryEdit: 803,
  // グループマスタ閲覧
  group: 901,
  // グループマスタ新規登録
  groupRegister: 902,
  // グループマスタ編集
  groupEdit: 903,
  // ユーザーマスタ閲覧
  user: 1001,
  // ユーザーマスタ編集
  userEdit: 1002
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__ = __webpack_require__("laiv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_utils_app_whitelist_js__ = __webpack_require__("9KKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__ = __webpack_require__("T3K/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_auth_index_js__ = __webpack_require__("9KlH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_restrict_access_index_js__ = __webpack_require__("4k6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_user_index_js__ = __webpack_require__("v1eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_env_js__ = __webpack_require__("AMf1");



var _this = this;

var frontAuthCheck = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(menu, next) {
    var authList;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            authList = Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["a" /* getLocalStore */])('AUTH_LIST');

            if (!(authList == null || authList.indexOf(menu) < 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt('return', false);

          case 3:
            return _context2.abrupt('return', true);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function frontAuthCheck(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();











var setToken = function setToken() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "rcD0"));
};
var unsupported = function unsupported() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "tN3a"));
};
var logout = function logout() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "KDEu"));
};
var app = function app() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "EWfp"));
};
var top = function top() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "eK/8"));
};
var test = function test() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "1J0P"));
};
var group = function group() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "5eIX"));
};
var groupDetail = function groupDetail() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "u2ok"));
};
var groupEdit = function groupEdit() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "zyjr"));
};
var category = function category() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "myWF"));
};
var categoryEdit = function categoryEdit() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "u1qj"));
};
var user = function user() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "aJGe"));
};
var userEdit = function userEdit() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "T/v1"));
};
var training = function training() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "vQ0K"));
};
var trainingRegister = function trainingRegister() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "P+Vp"));
};
var trainingEdit = function trainingEdit() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "Cy3V"));
};
var trainingPreview = function trainingPreview() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "y2jO"));
};
var trainingRecord = function trainingRecord() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "w56b"));
};
var trainingResult = function trainingResult() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "2fVZ"));
};
var takeTraining = function takeTraining() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "+G4a"));
};
var trainingOverview = function trainingOverview() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "kzTF"));
};
var exam = function exam() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "u6L7"));
};
var examRegister = function examRegister() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "UjkO"));
};
var examEdit = function examEdit() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "NLCs"));
};
var examPreview = function examPreview() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "xJc5"));
};
var examRecord = function examRecord() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "gnYs"));
};
var takeExam = function takeExam() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "3oZG"));
};
var examOverview = function examOverview() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "5KaT"));
};
var examResult = function examResult() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "Psme"));
};
var replicationRegister = function replicationRegister() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Vh7T"));
};
var replicationEdit = function replicationEdit() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "45NF"));
};
var replicationTraining = function replicationTraining() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "12Dk"));
};
var replicationTrainingOverview = function replicationTrainingOverview() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "JDrB"));
};
var trainingPreparation = function trainingPreparation() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "bOo4"));
};
var replicationExam = function replicationExam() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "VeAz"));
};
var replicationExamOverview = function replicationExamOverview() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "cyz6"));
};
var examPreparation = function examPreparation() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "c9+u"));
};
var questionList = function questionList() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "BJ6c"));
};
var grading = function grading() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "XoqB"));
};
var unadministeredRegister = function unadministeredRegister() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "1DvC"));
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/setToken/:shainNo/:tokenId',
    name: 'setToken',
    component: setToken,
    meta: {
      unnecessaryAuth: true,
      unnecessaryToken: true
    }
  }, {
    path: '/unsupported',
    name: 'unsupported',
    component: unsupported,
    meta: {
      unnecessaryAuth: true,
      unnecessaryToken: true
    }
  }, {
    path: '/logout',
    name: 'logout',
    component: logout,
    meta: {
      unnecessaryAuth: true
    }
  }, {
    path: '/',
    component: app,
    redirect: 'top',
    children: [{
      path: 'top',
      component: top,
      meta: {
        unnecessaryAuth: true
      }
    }, {
      path: '/group',
      component: group,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].group
      }
    }, {
      path: 'test',
      component: test,
      meta: {
        unnecessaryAuth: true,
        unnecessaryToken: true
      }
    }, {
      path: '/groupDetail/:hash',
      component: groupDetail,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].group
      }
    }, {
      path: '/groupEdit/:hash',
      component: groupEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].groupEdit
      }
    }, {
      path: '/category',
      component: category,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].category
      }
    }, {
      path: '/categoryEdit/:hash',
      component: categoryEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].categoryEdit
      }
    }, {
      path: '/user',
      component: user,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].user
      }
    }, {
      path: '/userEdit/:hash',
      component: userEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].userEdit
      }
    }, {
      path: '/training',
      component: training,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].training
      }
    }, {
      path: '/trainingRegister',
      component: trainingRegister,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].trainingRegister
      }
    }, {
      path: '/trainingEdit/:hash',
      component: trainingEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].trainingEdit
      }
    }, {
      path: '/trainingPreview',
      component: trainingPreview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].trainingRegister
      }
    }, {
      path: '/trainingRecord',
      component: trainingRecord,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].trainingRecord
      }
    }, {
      path: '/trainingRecord/trainingResult/:id',
      component: trainingResult,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].trainingRecord
      }
    }, {
      path: '/training/takeTraining/:hash',
      component: takeTraining,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].training
      }
    }, {
      path: '/training/trainingOverview/:hash',
      component: trainingOverview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].training
      }
    }, {
      path: '/exam',
      component: exam,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].exam
      }
    }, {
      path: '/examRecord',
      component: examRecord,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].examRecord
      }
    }, {
      path: '/examRegister',
      component: examRegister,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].examRegister
      }
    }, {
      path: '/examPreview',
      component: examPreview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].examRegister
      }
    }, {
      path: '/examEdit/:hash',
      component: examEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].examEdit
      }
    }, {
      path: '/exam/takeExam/:hash',
      component: takeExam,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].exam
      }
    }, {
      path: '/exam/examOverview/:hash',
      component: examOverview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].exam
      }
    }, {
      path: '/examRecord/examResult/:id',
      component: examResult,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].examRecord
      }
    }, {
      path: '/replicationRegister',
      component: replicationRegister,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationRegister
      }
    }, {
      path: '/replicationEdit/:hash',
      component: replicationEdit,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationEdit
      }
    }, {
      path: '/replicationTraining',
      component: replicationTraining,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationTraining
      }
    }, {
      path: '/replicationTraining/:replicationHash/:trainingHash',
      component: replicationTrainingOverview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationTraining
      }
    }, {
      path: '/training/trainingPreparation/:replicationHash/:trainingHash',
      component: trainingPreparation,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].training
      }
    }, {
      path: '/replicationExam',
      component: replicationExam,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationExam
      }
    }, {
      path: '/replicationExam/:replicationHash/:examHash',
      component: replicationExamOverview,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationExam
      }
    }, {
      path: '/exam/examPreparation/:replicationHash/:examHash',
      component: examPreparation,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].exam
      }
    }, {
      path: '/replicationExam/questionList/:replicationId/:examHash',
      component: questionList,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationExamScoring
      }
    }, {
      path: '/replicationExam/grading/:replicationId/:questionId',
      component: grading,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].replicationExamScoring
      }
    }, {
      path: '/UnadministeredRegister/:id',
      component: unadministeredRegister,
      meta: {
        menu: __WEBPACK_IMPORTED_MODULE_7__store_utils_func_id_list_js__["a" /* funcId */].unadministeredRegister
      }
    }]
  }, {
    path: '*',
    redirect: 'top'
  }]
});

// ログイン認証
router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var userAgent;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // ユーザエージェントの取得
            userAgent = window.navigator.userAgent.toLowerCase();

            // アプリの起動

            appOpen(userAgent);

            // 非対応ブラウザ判定

            if (unsupportedCheck(to, next, userAgent)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return');

          case 4:
            if (appWhitelistCheck(to, next, userAgent)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return');

          case 6:
            if (to.meta.unnecessaryAuth) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return frontAuthCheck(to.meta.menu, next);

          case 9:
            if (_context.sent) {
              _context.next = 12;
              break;
            }

            next({ path: '/top' });
            return _context.abrupt('return');

          case 12:
            if (!(typeof to.meta.unnecessaryToken !== 'undefined' && to.meta.unnecessaryToken)) {
              _context.next = 15;
              break;
            }

            next();
            return _context.abrupt('return');

          case 15:

            __WEBPACK_IMPORTED_MODULE_9__api_restrict_access_index_js__["a" /* CheckIp */](to.path).then(function (r) {
              __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].commit('forbidden', false);
              __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].commit('onLoading', true);
              if (!to.meta.menu) {
                __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].dispatch('transition/MENU', 0);
              } else {
                __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].dispatch('transition/MENU', to.meta.menu);
              }
              var accessToken = Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["a" /* getLocalStore */])('ACCESS_TOKEN');
              var refreshToken = Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["a" /* getLocalStore */])('REFRESH_TOKEN');
              var shainNo = Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["a" /* getLocalStore */])('SHAIN_NO');
              if (shainNo && accessToken && refreshToken) {
                __WEBPACK_IMPORTED_MODULE_8__api_auth_index_js__["a" /* checkAccessToken */](shainNo, accessToken).then(function (res) {
                  dispatchShainName(shainNo, ['ShainName']);
                  next();
                }).catch(function (res) {
                  var refreshToken = Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["a" /* getLocalStore */])('REFRESH_TOKEN');
                  __WEBPACK_IMPORTED_MODULE_8__api_auth_index_js__["b" /* checkRefreshToken */](shainNo, refreshToken).then(function (r) {
                    dispatchShainName(shainNo, ['ShainName']);
                    next();
                  }).catch(function (r) {
                    resetRedirect();
                  });
                });
              } else {
                resetRedirect();
              }
            }).catch(function (e) {
              console.log(e);
              __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].commit('forbidden', true);
              next();
            });

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

function dispatchShainName(shainNo, name) {
  if (!__WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].state.auth.shainName) {
    __WEBPACK_IMPORTED_MODULE_10__api_user_index_js__["e" /* getShainInfo */](Number(shainNo), name).then(function (r) {
      __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].dispatch('auth/SHAIN_NAME', r.data.ShainName);
    }).catch(function (e) {
      console.log(e);
    });
  }
}

function appOpen(userAgent) {
  if (userAgent.indexOf(__WEBPACK_IMPORTED_MODULE_11__config_env_js__["b" /* appName */].toLowerCase()) === -1) {
    var target = ['iphone', 'android', 'ipad', 'ipod'];
    var len = target.length;
    for (var i = 0; i < len; ++i) {
      if (userAgent.indexOf(target[i]) > -1) {
        var host = location.hostname;
        var path = location.pathname;
        var parameter = '?host=' + host + '&path=' + path;
        location.href = 'appname://' + __WEBPACK_IMPORTED_MODULE_11__config_env_js__["b" /* appName */] + parameter;
        break;
      }
    }
  }
}

function unsupportedCheck(to, next, userAgent) {
  var res = true;
  if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    if (to.path !== '/unsupported') {
      res = false;
      next({ path: '/unsupported' });
    }
  }
  return res;
}

function appWhitelistCheck(to, next, userAgent) {
  if (userAgent.indexOf(__WEBPACK_IMPORTED_MODULE_11__config_env_js__["b" /* appName */].toLowerCase()) === -1 || to.path === '/top') {
    return true;
  }
  var res = false;
  var split = to.path.split('/');
  var splitLen = split.length;
  var x = __WEBPACK_IMPORTED_MODULE_6__store_utils_app_whitelist_js__["a" /* appWhitelist */].length;
  for (var a = 0; a < x; ++a) {
    var y = __WEBPACK_IMPORTED_MODULE_6__store_utils_app_whitelist_js__["a" /* appWhitelist */][a].length;
    for (var b = 0; b < y; ++b) {
      if (b <= splitLen && split[b + 1] === __WEBPACK_IMPORTED_MODULE_6__store_utils_app_whitelist_js__["a" /* appWhitelist */][a][b]) {
        if (b - 0 === y - 1) {
          res = true;
          break;
        }
      } else {
        break;
      }
    }
    if (res) break;
  }
  if (!res) next({ path: '/top' });
  return res;
}

function resetRedirect() {
  Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["b" /* removeLocalStore */])('ACCESS_TOKEN');
  Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["b" /* removeLocalStore */])('REFRESH_TOKEN');
  Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["b" /* removeLocalStore */])('SHAIN_NO');
  Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["b" /* removeLocalStore */])('AUTH_ID');
  Object(__WEBPACK_IMPORTED_MODULE_5__store_utils_storage_js__["b" /* removeLocalStore */])('AUTH_LIST');
  __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].dispatch('auth/SHAIN_NAME', '');
  var pathname = location.pathname;
  location.href = __WEBPACK_IMPORTED_MODULE_11__config_env_js__["c" /* authUrl */] + '/login?' + 'url=' + __WEBPACK_IMPORTED_MODULE_11__config_env_js__["d" /* myUrl */] + '/setToken' + '&transition=' + pathname;
}

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].commit('onLoading', false);
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "laiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLocalStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeLocalStore; });
/* unused harmony export clearLocalStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSessionStore; });
/* unused harmony export getSessionStore */
/* unused harmony export removeSessionStore */
/* unused harmony export clearSessionStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/*
 * * ローカルストレージにセット
 * */
var setLocalStore = function setLocalStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  localStorage.setItem(name, content);
};

/**
 *  * ローカルストレージから取得
 *   */
var getLocalStore = function getLocalStore(name) {
  if (!name) return;
  return localStorage.getItem(name);
};

/**
 *  * ローカルストレージから削除
 *   */
var removeLocalStore = function removeLocalStore(name) {
  if (!name) return;
  localStorage.removeItem(name);
};

/*
 * * ローカルストレージを全て削除
 * */
var clearLocalStore = function clearLocalStore() {
  localStorage.clear();
};
/*
 * * セッションストレージにセット
 * */
var setSessionStore = function setSessionStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  sessionStorage.setItem(name, content);
};

/**
 *  * ローカルストレージから取得
 *   */
var getSessionStore = function getSessionStore(name) {
  if (!name) return;
  return sessionStorage.getItem(name);
};

/**
 *  * ローカルストレージから削除
 *   */
var removeSessionStore = function removeSessionStore(name) {
  if (!name) return;
  sessionStorage.removeItem(name);
};

/*
 * * ローカルストレージを全て削除
 * */
var clearSessionStore = function clearSessionStore() {
  sessionStorage.clear();
};

/***/ }),

/***/ "pyT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__ = __webpack_require__("AZxf");



var state = {
  menu: ''
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], function (state, _ref) {
  var num = _ref.num;

  state.menu = num;
});

var getters = {
  getMenu: function getMenu(state) {
    return state.menu;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], function (_ref2, num) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__utils_mutation_types_js__["c" /* MENU */], { num: num });
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "v1eo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoInputUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShainInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectOneRecordUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return edit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env_js__ = __webpack_require__("AMf1");


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

var getSelectMember = function getSelectMember(ShainNo, ShainName, DeptId, DivisionId, GroupId, HireOnStart, HireOnEnd, PostId, PointOfTime) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selectMember', {
    'shain_no': ShainNo - 0,
    'shain_name': ShainName,
    'dept_id': DeptId.map(Number),
    'division_id': DivisionId.map(Number),
    'group_id': GroupId.map(Number),
    'hire_on_start': HireOnStart,
    'hire_on_end': HireOnEnd,
    'post_id': PostId.map(Number),
    'point_of_time': PointOfTime
  });
};

var AutoInputUserName = function AutoInputUserName(shainNo) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/getShainName/' + shainNo);
};

var getShainInfo = function getShainInfo(ShainNo, Option) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/selective', {
    'shain_no': ShainNo - 0,
    'option': Option
  });
};

var Search = function Search(shainNo, shainName, selectAuthList) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user', {
    'shain_no': shainNo - 0,
    'shain_name': shainName,
    'select_auth_list': selectAuthList.map(Number)
  });
};

var selectOneRecordUser = function selectOneRecordUser(Hash) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/' + Hash);
};

var edit = function edit(ShainNo, AuthId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__config_env_js__["a" /* apiUrl */] + '/user/edit', {
    'shain_no': ShainNo,
    'auth_id': AuthId - 0
  });
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3b3f4e8884aa2302b231.js